import { useAppSelector } from '@/Application/Hooks/Redux';
import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';
import { isDeviceKiosco } from '@/modules/shared/utils/deviceDetections';
import { useCustomerContext } from '@/sections/customer/CustomerContext';

export const BuyerInformation = () => {
  const { data: cart } = useAppSelector((state) => state.cart);
  const shippingAddress = cart?.shippingAddress;
  const billingAddress = cart?.billingAddress;
  const isKiosco = isDeviceKiosco();

  const customerContext = useCustomerContext();
  const customerData = customerContext?.customer?.data;
  const customerRut = customerData?.rut ?? '';
  const customerName = customerData?.firstName ?? '';
  const customerLastName = customerData?.lastName ?? '';
  const customerEmail = customerData?.email ?? '';
  const customerPhone = customerData?.phone ?? '';

  let rut = customerRut;
  let email = customerEmail;
  let phone = shippingAddress?.phone ?? billingAddress?.phone ?? customerPhone;
  let firstName = customerName;
  let lastName = customerLastName;
  let fullName = `${firstName} ${lastName}`;

  if (isKiosco) {
    rut = shippingAddress?.customerRut ?? '';
    email = shippingAddress?.email ?? '';
    phone = shippingAddress?.phone ?? '';
    firstName = shippingAddress?.firstName ?? '';
    lastName = shippingAddress?.lastName ?? '';
    fullName = `${firstName} ${lastName}`;
  }

  return (
    <div className="co-flex co-flex-col co-font-">
      <div className="co-mb-4">
        <Typography size="body1" weight="semibold">
          Datos de quien compra
        </Typography>
      </div>
      <Typography size="body1" weight="medium">
        Nombre: {fullName}
      </Typography>
      <Typography size="body1" weight="medium">
        RUT: {rut}
      </Typography>
      <Typography size="body1" weight="medium">
        Correo: {email}
      </Typography>
      <Typography size="body1" weight="medium">
        Teléfono: {phone}
      </Typography>
    </div>
  );
};
